import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { HomeContext } from '../contexts/home/context';
import jwtDecode from 'jwt-decode';
import { useCheckAdminLoggedIn } from 'hooks/useCheckAdminLoggedIn';
import { useKeycloakReady } from 'hooks';
// import { sessionStorageService } from 'utils/SessionStorageService';

export function RequireAuth() {
  const { keycloak, initialized } = useKeycloak();
  const { tokenParsed } = useKeycloakReady();
  const location = useLocation();
  const { state } = useContext(HomeContext);
  const isAdminLoggedIn = useCheckAdminLoggedIn();
  // const genbravoSessionFlag = sessionStorageService.get('genbravoSessionFlag');
  // if (!genbravoSessionFlag) {
  //   return (
  //     <Navigate
  //       to="/login"
  //       state={
  //         state.userAccess || location.pathname.includes('/eob')
  //           ? { from: { pathname: location.pathname + location.search } }
  //           : null
  //       }
  //       replace
  //     />
  //   );

  // } else
  if (initialized && !keycloak.authenticated) {
    return (
      <Navigate
        to="/login"
        state={
          state.userAccess || location.pathname.includes('/eob')
            ? { from: { pathname: location.pathname + location.search } }
            : null
        }
        replace
      />
    );
  }

  if (isAdminLoggedIn) {
    if (tokenParsed?.ebClientKey == '' && tokenParsed?.ilClientKey != '') {
      // if (!location?.pathname.startsWith('/admin')) {
      //   return <Navigate to="/admin" replace />;
      // }
      console.log('now is only life');
    } else {
      const { memberId }: { memberId: string } = jwtDecode(keycloak.token ?? '');
      if (!memberId && !location?.pathname.startsWith('/admin')) {
        return <Navigate to="/admin" replace />;
      }
    }
  }

  return <Outlet />;
}
